import { useContext } from './Context'
import React from 'react'
import { QueryTemplateInputValue } from '../../../Template/TemplateValue/Query/Input'

export const QueryTemplateInputValueWithFields = () => {
  const { filterFields } = useContext()
  return <QueryTemplateInputValue filterFields={filterFields} />
}
